<template lang="pug">
.window(:class="{'window-active': isActive}")
  .backdrop(
    @click="onBackgroundClick"
    :style="{'z-index': zLevel}"
    v-if="background")
  .window-content(:class="position", :style="{'z-index': Number(zLevel) + 1}")
    slot
</template>

<script>
export default {
  name: 'PopWindow',
  data() {
    return {
      isActive: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'right',
    },
    background: {
      type: Boolean,
      default: true,
    },
    zIndex: {
      type: Number,
      default: null,
    },
  },
  computed: {
    zLevel() {
      return this.zIndex || 100;
    },
  },
  methods: {
    onBackgroundClick() {
      this.$emit('onBackgroundClick');
    },
    appendWindow() {
      if (this.visible) {
        document.body.appendChild(this.$el);
      }
      setTimeout(() => {
        this.isActive = this.visible;
      }, 100);
    },
  },
  watch: {
    visible() {
      this.appendWindow();
    },
  },
  mounted() {
    this.appendWindow();
  },
};
</script>

<style lang="stylus" scoped>
.window
  .backdrop
    position fixed
    z-index 9
    top 0
    left 0
    right 0
    bottom 0
    pointer-events none
    background-color rgba(0, 0, 0, 0.3)
    opacity 0
    transition opacity 0.5s cubic-bezier(0.35, 0, 0.25, 1)
  .window-content
    position fixed
    z-index 10
    pointer-events none
    transition transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)
    height 100%
  .left
    top 0
    left 0
    bottom 0
    transform translate(-100%, 0)
  .top
    top 0
    left 0
    right 0
    transform translate(0, -100%)
  .right
    top 0
    right 0
    bottom 0
    transform translate(100%, 0)
  .bottom
    left 0
    bottom 0
    right 0
    transform translate(0, 100%)

.window-active
  .backdrop
    opacity 1
    pointer-events auto
  .window-content
    pointer-events auto
    transform translate(0, 0)
</style>



// WEBPACK FOOTER //
// PopWindow.vue?02c847be